import moment from 'moment';
/**
 * A class that can return the Attendance model
 */
export class Attendance {
  /** @param {Object} attendance FastJson object. */
  constructor(attendance = {}) {
    this.id = attendance.user?.id || null;
    this.firstName = attendance.user.first_name || null;
    this.lastName = attendance.user.last_name || null;
    this.fullName = `${attendance.user.first_name || ''} ${attendance.user.last_name || ''}`.trim();
    this.violations = (attendance.violations || []).map((violation) => ({
      type: violation.type || null,
      date: violation.date ? moment(violation.date).format('YYYY-MM-DD') : null,
      expectedTime: violation.expected_time && moment(violation.expected_time, moment.ISO_8601, true).isValid()?
        moment.parseZone(violation.expected_time).format('hh:mm A'):
        null,
      actualTime: violation.actual_time && moment(violation.actual_time, moment.ISO_8601, true).isValid()?
        moment.parseZone(violation.actual_time).format('hh:mm A'):
        null
    }));
  }
}
